// extracted by mini-css-extract-plugin
module.exports = {"content":"LatestEdit_content__dnF_G"};